import { ApolloError } from '@apollo/client'

import { getTranslate } from '../localization'

/**
 * Operator-facing copy for a failed list load.
 *
 * A GraphQL error has been through the BFF's status-code allowlist and is safe
 * to show. A network or proxy failure never reaches that mapping, so its
 * message is a transport string like "Network error: Failed to fetch" —
 * untranslated, and meaningless to a hotel operator.
 *
 * The agent queue already made this distinction and the ticket list did not,
 * so the raw Apollo string was rendered on the screen EVERY user lands on
 * while the careful treatment sat on the admin-only one. Extracted so the two
 * cannot diverge again.
 */
export function listLoadErrorMessage(
  error: ApolloError | undefined,
  validationError: string | undefined,
  fallbackKey: string
): string {
  if (validationError) return getTranslate(validationError)
  if (error?.graphQLErrors?.length) return error.message

  return getTranslate(fallbackKey)
}
